import React from 'react'
import { FormControl, Select, MenuItem, InputLabel } from '@mui/material'

/**
 * Items per page selector component
 */
const ItemsPerPageSelector = ({
  itemsPerPage,
  setItemsPerPage,
  loading,
  options = [10, 30],
}) => {
  const handleChange = (event) => {
    setItemsPerPage(Number(event.target.value))
    setTimeout(() => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    }, 10)
  }

  return (
    <FormControl size='small' sx={{ minWidth: 140 }}>
      <InputLabel
        sx={{
          '&.Mui-focused': {
            color: '#232536',
          },
        }}
      >
        Results per page
      </InputLabel>
      <Select
        value={itemsPerPage}
        onChange={handleChange}
        disabled={loading}
        label='Results per page'
        aria-label='Items per page'
        inputProps={{
          'aria-label': 'Number of items to display per page',
        }}
        sx={{
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#232536',
          },
        }}
        MenuProps={{
          PaperProps: {
            sx: {
              '& .MuiMenuItem-root': {
                '&:hover': {
                  backgroundColor: '#f5f5f5',
                },
                '&.Mui-selected': {
                  backgroundColor: '#e8e8e8',
                  '&:hover': {
                    backgroundColor: '#d5d5d5',
                  },
                },
              },
            },
          },
        }}
      >
        {options.map((option) => (
          <MenuItem key={option} value={option}>
            {option}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

export default ItemsPerPageSelector
